import itemSearch from "@/components/iglobalwin/formComponents/SkySuffix.vue";
const formStore = {
  components: {
    itemSearch
  },
  props: {
    value: [String, Number, Boolean, Object, Array],
    delay: Boolean
  },
  data() {
    return {
      selfData: null
    };
  },
  watch: {
    value: {
      handler (val, oldval) {
        this.selfData = val;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    change (val) {
      this.selfData = val;
      !this.delay && this.setVal();
      this.$emit("change", val);
    },
    setVal() {
      this.$emit("input", this.selfData);
    },
    getVal() {
      this.selfData = this.value;
    }
  },
  mounted() {
    this.selfData = this.value;
  }
};
export default formStore;
